// extracted by mini-css-extract-plugin
module.exports = {"root":"figure-module--root--1FdyK","caption":"figure-module--caption--6tuFo typography-module--small--zBmMs"};